import type { AdminReportMediaDto } from '@carcheck/shared';
import type { TFunction } from 'i18next';

/**
 * Per-item visible labels for a report's media list — "фото 1", "видео 2",
 * "PDF 1" (AUT-429 — a document used to be counted as a photo).
 *
 * The index is TYPE-LOCAL and runs over the list in wire order, so the
 * operator can name a specific shot ("в фото 6 не видно VIN") without
 * caring about the category. Computed in one pass and shared by the grid
 * and the Lightbox, so the label on the tile is the same label the
 * operator sees after clicking it (AUT-272 — they diverged when each
 * surface counted for itself).
 */
export interface LabeledReportMedia {
  item: AdminReportMediaDto;
  label: string;
}

export const labelReportMedia = (
  media: AdminReportMediaDto[],
  t: TFunction,
): LabeledReportMedia[] => {
  let photoIdx = 0;
  let videoIdx = 0;
  let pdfIdx = 0;

  return media.map((item) => {
    switch (item.mediaType) {
      case 'photo':
        photoIdx += 1;
        return { item, label: t('reports.mediaTab.photoLabel', { index: photoIdx }) };
      case 'video':
        videoIdx += 1;
        return { item, label: t('reports.mediaTab.videoLabel', { index: videoIdx }) };
      case 'document':
        pdfIdx += 1;
        return { item, label: t('reports.mediaTab.pdfLabel', { index: pdfIdx }) };
      default: {
        const unreachable: never = item.mediaType;
        return unreachable;
      }
    }
  });
};
